module.exports = __webpack_public_path__ + "static/img/labourservices-6.5562895.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservices-6.png
// module id = 5KCo
// module chunks = 1